import styled from 'styled-components/macro'
import { Label } from 'components/lib'

export const SectionLabel = styled(Label)`
  font-size: 16px;
  margin-bottom: 16px;
  margin-top: 32px;
`
